import { liveQuery } from 'dexie';
import { useEffect, useState } from 'react';

/** Suscripción reactiva a una consulta de Dexie: el componente se actualiza cuando cambian los datos. */
export function useVivo<T>(consulta: () => Promise<T> | T, deps: unknown[], inicial: T): T {
  const [valor, setValor] = useState<T>(inicial);
  useEffect(() => {
    const sub = liveQuery(consulta).subscribe({ next: (v) => setValor(v), error: (e) => console.error(e) });
    return () => sub.unsubscribe();
  }, deps);
  return valor;
}
